export const SUCCESS_CODE = 2000;
export const SUCCESS_CODE_SIGNUP = 2002;
export const PARAM_MISSING_CODE = 4000;
export const NO_DATA_FOUND = 2004;
export const FAILURE = -4;